import { render, staticRenderFns } from "./Tender.vue?vue&type=template&id=8651c7b6&scoped=true&"
import script from "./Tender.vue?vue&type=script&lang=ts&"
export * from "./Tender.vue?vue&type=script&lang=ts&"
import style0 from "./Tender.vue?vue&type=style&index=0&id=8651c7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8651c7b6",
  null
  
)

export default component.exports